import { RefreshCw, WifiOff } from "lucide-react";

function ago(ts) {
  const mins = Math.round((Date.now() - ts) / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins} min ago`;
  const d = new Date(ts);
  const sameDay = d.toDateString() === new Date().toDateString();
  return sameDay
    ? `at ${d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}`
    : d.toLocaleString("en-GB", { weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
}

// "Live · updated 2 min ago" / "Offline · prices from Tue 14:32"
export default function PriceStatus({ wealth, className = "" }) {
  const { online, fetchedAt, refreshing, lastError, refresh, hasLiveHoldings } = wealth;
  if (!hasLiveHoldings) return null;

  let text;
  if (!online) text = fetchedAt ? `Offline · prices from ${ago(fetchedAt)}` : "Offline · no prices yet";
  else if (refreshing) text = "Updating prices…";
  else if (lastError) text = `${lastError}${fetchedAt ? ` · showing prices from ${ago(fetchedAt)}` : ""}`;
  else text = fetchedAt ? `Live · updated ${ago(fetchedAt)}` : "Live prices";

  return (
    <div className={`flex items-center gap-2 text-xs text-nest-muted ${className}`} data-testid="price-status">
      {online ? (
        <span className={`w-1.5 h-1.5 rounded-full ${lastError ? "bg-nest-warn" : "bg-nest-good-soft"}`} />
      ) : (
        <WifiOff size={12} />
      )}
      <span>{text}</span>
      {online && (
        <button
          onClick={refresh}
          disabled={refreshing}
          className="text-nest-faint hover:text-nest-brand disabled:opacity-50"
          aria-label="Refresh prices"
          data-testid="refresh-prices-btn"
        >
          <RefreshCw size={12} className={refreshing ? "animate-spin" : ""} />
        </button>
      )}
    </div>
  );
}
